import { ChoiceFlat } from "@pdfking/forms"
import type { DestinationID } from "@pdfking/imposition"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { Items, RecordCreate } from "@pdfking/tfunc"

import { IDMixin } from "../../mixins/IDMixin"
import { dom_id } from "../dispatch/DomId"
import { DjSelect } from "../fields/DjSelect"
import { FieldMixin } from "../mixins/FieldMixin"
import { ChoiceFormMixin } from "../mixins/FormMixin"
import { NodeMixin } from "../mixins/NodeMixin"

export const FileDestination = CreateRenderFunction({
  mixins: [NodeMixin, FieldMixin, IDMixin, ChoiceFormMixin] as const,

  render() {
    // A packed imposition only plots the destinations it laid out, so the picker
    // narrows to those; a view that imposes nothing (the files preset) accepts
    // them all. Labels stay the field's own — the imposition only says which.
    const allowed = this.ctx.file_destinations
    const choices = RecordCreate(
      Items(ChoiceFlat(this.node!.choices))
        .filter(([id]) => allowed.has(id as DestinationID))
        .map(([id, choice]) => [id, this.node!.format(choice)] as const)
    )
    return (
      <DjSelect
        choices={choices}
        disabled={this.disabled}
        error={this.node!.error}
        dom_id={dom_id(this)}
        onselect={this.node!.validate}
        input={this.node!.input}
      />
    )
  },
})
